import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19.5 11.5C19.5 15.9183 15.9183 19.5 11.5 19.5M19.5 11.5C19.5 7.08172 15.9183 3.5 11.5 3.5M19.5 11.5H17M19.5 11.5H22M11.5 19.5C7.08172 19.5 3.5 15.9183 3.5 11.5M11.5 19.5V17M11.5 19.5V22M3.5 11.5C3.5 7.08172 7.08172 3.5 11.5 3.5M3.5 11.5H6M3.5 11.5H1M11.5 3.5V1M11.5 3.5V6M9 14L14 9M14 14L9 9",
  stroke: "currentColor",
  "stroke-linejoin": "round"
}, null, -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }